import React from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, LineElement, PointElement, CategoryScale, LinearScale, Title, Legend } from 'chart.js';
ChartJS.register(
    LineElement,
    PointElement,
    CategoryScale,
    LinearScale,
    Title,
    Legend
);

const ogttTblLabel = ["Fasting", "1/2 Hour", "1 Hour", "1 1/2 Hour", "2 Hour", "2 1/2 Hour", "3 Hour"];
const chartFont = "Open Sans";

const options = {
    responsive: true,
    maintainAspectRatio: false,
    spanGaps: true,
    plugins: {
        legend: {
            display: true
        },
        title: {
            display: false
        },
        tooltip: {
            titleFont: {
                family: chartFont,
            },
            bodyFont: {
                family: chartFont,
            },
        }
    },
    scales: {
        x: {
            grid: {
                color: 'rgba(0, 0, 0, 0)',
                drawBorder: false,
            },
            ticks: {
                align: 'center',
                font: {
                    weight: 'bold',
                    family: chartFont,
                    size: 12
                }
            },
            title: {
                display: true,
                text: 'Time',
                color: 'black',
                font: {
                    weight: 'bold',
                    size: 14,
                    family: chartFont,
                }
            }
        },
        y: {
            beginAtZero: false,
            ticks: {
                align: 'center',
                font: {
                    weight: 'bold',
                    family: chartFont
                }
            },
            title: {
                display: true,
                text: 'Glucose Level (mg/dL)',
                color: 'black',
                font: {
                    weight: 'bold',
                    size: 14,
                    family: chartFont,
                }
            }
        }
    },
};

const OgttGraph = ({ ogttData }) => {
    const strictNumberInRange = (val, min = 20, max = 999) => {
        if (val === null || val === "" || !isFinite(val)) return false;
        if (typeof val === "string" && /e/i.test(val)) return false;
        const num = Number(val);
        return num >= min && num <= max;
    };

    const getValue = (data) => {
        return Object.values(data)?.map(val => strictNumberInRange(val) ? Number(val) : null);
    };

    const allUrineValid = Object.values(ogttData.urineGlucose)?.every(val => val === null || val === "" || isFinite(val));

    const data = {
        labels: ogttTblLabel,
        datasets: [
            {
                label: 'Blood Glucose',
                data: getValue(ogttData.bloodGlucose),
                backgroundColor: "#04B7B1",
                borderColor: "#04B7B1",
            },
            ...(allUrineValid ? [{
                label: 'Urine Glucose',
                data: getValue(ogttData.urineGlucose),
                borderColor: 'rgba(54, 162, 235, 1)',
                backgroundColor: 'rgba(54, 162, 235, 0.2)',
            }] : [])
        ]
    };

    return (
        <div style={{ height: '100%' }}>
            <Line options={options} data={data} />
        </div>
    );
}

export default OgttGraph